import type { ComponentPropsWithRef } from "react";

import { cn } from "@intergamma/common/cn";

export function Pencil({ className, ...props }: ComponentPropsWithRef<"svg">) {
  return (
    <>
      <svg
        className={cn("karwei:hidden", className)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          id="icon"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0551 2.88389C16.1291 1.80995 17.8703 1.80994 18.9442 2.88389L21.3518 5.29142C22.4257 6.36536 22.4257 8.10656 21.3518 9.1805L11.2119 19.3203C10.9721 19.5602 10.6678 19.7251 10.336 19.7952L5.49148 20.8179C4.25394 21.0792 3.15648 19.9817 3.41774 18.7442L4.44048 13.8997C4.51053 13.5679 4.67549 13.2635 4.9153 13.0237L15.0551 2.88389ZM17.8836 3.94455C17.3954 3.45639 16.6039 3.45639 16.1158 3.94455L15.2964 4.76398L19.3962 9.01469L20.2911 8.11984C20.7792 7.63169 20.7792 6.84023 20.2911 6.35208L17.8836 3.94455ZM6.06031 14L14.2355 5.82482L18.3354 10.0755L10.2356 18.1753L6.06031 14ZM5.6014 15.6624L4.88539 19.054C4.84807 19.2308 5.00485 19.3876 5.18164 19.3502L8.57319 18.6342L5.6014 15.6624Z"
          fill="currentColor"
        />
      </svg>
      <svg
        className={cn("gamma:hidden", className)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.0612 2.35365C17.4754 1.76786 16.5256 1.76786 15.9398 2.35365L5.0929 13.2006C4.88735 13.4061 4.74595 13.667 4.68591 13.9514L3.50461 19.5469C3.35532 20.2541 3.98244 20.8812 4.68961 20.7319L10.2851 19.5507C10.5696 19.4906 10.8304 19.3492 11.036 19.1437L21.8829 8.29671C22.4687 7.71092 22.4687 6.76118 21.8829 6.17539L18.0612 2.35365ZM16.6469 3.06075C16.8422 2.86549 17.1588 2.86549 17.3541 3.06075L21.1758 6.8825C21.3711 7.07776 21.3711 7.39434 21.1758 7.5896L19.3938 9.37155L14.9468 4.76091L16.6469 3.06075ZM14.2396 5.46813L5.8 13.9077C5.73149 13.9762 5.68436 14.0632 5.66434 14.158L4.48305 19.7535L10.0786 18.5722C10.1734 18.5522 10.2603 18.5051 10.3289 18.4366L18.6866 10.0788L14.2396 5.46813Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
}
